<template>
  <layout class="bg-transparent">
    <div class="w-full adm-container">
      <div class="bg-white rounded border border-grey-light flex p-4 sm:flex-col lg:flex-row">
        <div class="flex sm:w-full lg:w-4/5 sm:flex-col lg:flex-row sm:items-center lg:items-start">
          <pt-avatar />
          <h1 class="flex-1 flex items-center h-full ml-4">{{ user.name }}</h1>
        </div>
        <div class="flex items-center sm:justify-center lg:justify-end sm:w-full lg:w-1/5 sm:mt-4 lg:mt-0">
          <router-link
            to="/profile-management/view-documents"
            class="bg-primary no-underline text-white rounded py-2 px-4 uppercase font-bold"
          >View Documents
            <i
              class="fa fa-long-arrow-right"
              aria-hidden="true"
            />
          </router-link>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <pt-form class="bg-transparent border-none profile-form sm:w-4/5 lg:w-1/2">
        <pt-form-group
          label="Email"
          label-for="email"
        >
          <pt-form-input
            id="email"
            v-model="user.email"
            type="email"
            readonly
          />
        </pt-form-group>
        <pt-form-group
          label="Address"
          label-for="address"
        >
          <pt-form-input
            id="address"
            v-model="user.address"
            type="address"
            readonly
          />
        </pt-form-group>
        <pt-form-group
          label="City"
          label-for="city"
        >
          <pt-form-input
            id="city"
            v-model="user.city"
            type="text"
            readonly
          />
        </pt-form-group>
        <pt-form-group
          label="Country"
          label-for="country"
        >
          <pt-form-input
            id="country"
            v-model="user.country"
            type="text"
            readonly
          />
        </pt-form-group>
        <pt-form-group
          class="flex-1"
          label="Phone"
          label-for="phone"
        >
          <pt-form-input
            id="phone"
            v-model="user.phone"
            type="text"
            readonly
          />
        </pt-form-group>
      </pt-form>
    </div>
  </layout>
</template>

<script>
import { PtForm, PtFormGroup, PtFormInput, PtFormSwitch } from '@pathao/ui-components/esm/FormComponents';
import { PtButton } from '@pathao/ui-components/esm/Button';
import PtAvatar from '@components/custom/Avatar';
import Layout from '@layouts/main';

export default {
  name: 'Profiles',
  page: {
    title: 'Profiles',
  },
  components: { PtAvatar, PtButton, PtForm, PtFormGroup, PtFormInput, PtFormSwitch, Layout },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
